import { SkeletonContainer } from './Skeleton.styled';

export const Skeleton = ({ height, width }) => <SkeletonContainer style={{ height, width }} />;
